/**
 * Checks whether two string arrays contain the same values in the same order.
 *
 * @param a - The first array.
 * @param b - The second array.
 * @returns `true` if both arrays have the same length and equal values at every index.
 */
export function areStringArraysEqual(a: string[], b: string[]): boolean {
  return a.length === b.length && a.every((value, index) => value === b[index]);
}
